import React, { Component } from "react"

/**
 * A single Rain Diary entry. Contains header information and all three of
 * rain walk, consumption notes and analysis.
 *
 * @class      Diaries (name)
 */
class Diaries extends Component {
  render() {
    let entry = this.props.entry
    let walk = entry.walk
    let consumption = entry.consumption
    let analysis = entry.analysis

    return (
      <div>
        <dl>
          <dt>Key words</dt>
          <dd>{entry.keywords.join(", ")}</dd>
        </dl>

        <h2>Rain walk notes</h2>
        <dl>
          <dt>Rain walker</dt>
          <dd>{walk.actor}</dd>
          <dt>Date and time</dt>
          <dd>{walk.date}</dd>
          <dt>Route</dt>
          <dd>{walk.location}</dd>
          <dt>Water from</dt>
          <dd>{walk.waterFrom}</dd>
        </dl>
        <div>
          {walk.body.map(paragraph => (
            <p>{paragraph}</p>
          ))}
        </div>

        <h2>Consumption notes</h2>
        <dl>
          <dt>Rain consumer</dt>
          <dd>{consumption.actor}</dd>
          <dt>Rain sample</dt>
          <dd>{walk.date}</dd>
          <dt>Date and time</dt>
          <dd>{consumption.date}</dd>
          <dt>Route</dt>
          <dd>{consumption.location}</dd>
        </dl>
        <div>
          {consumption.body.map(paragraph => (
            <p>{paragraph}</p>
          ))}
        </div>

        <h2>Analysis</h2>
        <div>
          {analysis.body.map(paragraph => (
            <p>{paragraph}</p>
          ))}
        </div>
      </div>
    )
  }
}

export default Diaries



// WEBPACK FOOTER //
// ./src/pages/Diaries.js